import { getGatewayUrl } from "../utils/get-api-url";

export const postPolicyTransaction = async ({
  commit = false,
  policyId,
  insightPolicyId,
  type,
  user,
  version,
  reasonCode,
  reason,
  specificChanges = null,
  effectiveDate = null,
  IPMAction = null
}) => {
  const apiUrl = getGatewayUrl("pxcentral");
  const fullUrl = `${apiUrl}/policies/${insightPolicyId}`;

  const response = await fetch(fullUrl, {
    method: "POST",
    credentials: "include",
    body: buildTran({
      policyId,
      insightPolicyId,
      type,
      user,
      version,
      reasonCode,
      reason,
      specificChanges,
      effectiveDate
    }),
    headers: {
      "Content-Type": "application/xml; schema=transactionrequest.1.4",
      Accept: "application/vnd.ics360.insurancepolicy.2.8+xml",
      "X-Commit": commit,
      "X-IPM-Action": IPMAction
    }
  });

  const { statusText, ok, status } = response;
  const text = await response.text();

  if (!ok)
    throw Object.assign(new Error(text.message || statusText), { status });

  return text;
};

const buildTran = ({
  policyId,
  insightPolicyId,
  type,
  user,
  version,
  reasonCode,
  reason,
  specificChanges,
  effectiveDate
}) => {
  return `<?xml version="1.0"?>
<TransactionRequest schemaVersion="1.4" type="${type}">
  <Initiation>
    <Initiator type="user">${user}</Initiator>
  </Initiation>
  <Target>
    <Identifiers>
      <Identifier name="InsightPolicyId" value="${insightPolicyId}"/>
      <Identifier name="PolicyID" value="${policyId}"/>
    </Identifiers>
    <SourceVersion>${version}</SourceVersion>
  </Target>
  ${effectiveDate ? `<EffectiveDate>${effectiveDate}</EffectiveDate>` : ""}
  <ReasonCode>${reasonCode}</ReasonCode>
  <Comment>${reason}</Comment>
  ${specificChanges ? specificChanges : ""}
</TransactionRequest>`;
};
